export default {
    getTicketDetails: (env, ticketId) => {
        return {
            url: `/${env}/ticket/:ticketId`,
            method: 'GET',
            route_params: {
                ticketId
            }
        };
    },
    getTicketsByHomeId: (env, homeId) => {
        return {
            url: `/${env}/ticket/:homeId`,
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    getTicketHistory: (env, ticketId, offset, limit) => {
        return {
            url: `/${env}/ticket/:ticketId/history`,
            method: 'GET',
            route_params: {
                ticketId
            },
            get_params: {
                offset,
                limit
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Ticket/api.js